"use strict";

var ubian = ubian || {};
/**
 * card buy related methods
 * @type Object
 */
ubian.cardBuy = {};

ubian.cardBuy.checkUserBirthDate = function () {
  if ($("#birthDate").length) {
    var birthDate = moment($("#birthDate").val(), "YYYY-MM-DD");

    if (birthDate.isValid()) {
      var userAge = moment().diff(birthDate, "months") / 12;
      if (userAge < 16 && userAge > 0) {
        $("#containerDelegate").slideDown();
      } else if (userAge >= 16) {
        $("#containerDelegate").slideUp();
      }
    }
    setTimeout(ubian.cardBuy.checkInputFields(), 1000);
  }
};

ubian.cardBuy.uploadImage = function (file, cropper) {
  if (file === null && file.length === 0) {
    return;
  }
  var $formData = new FormData();
  //$formData.append("file", $("#photo")[0].files[0]);
  $formData.append("file", file);
  $formData.append("fileType", "1");
  $formData.append("validateFace", "true");
  $formData.append("isBase64", "true");
  $(".js-photo-preview-wrapper").removeClass("empty");
  $(".js-photo-preview-wrapper").addClass("loading");
  console.log("Upload image : " + ubian.routes["card_buy_upload_image"]);
  $.ajax({
    url: ubian.routes["card_buy_upload"].replace("--type--", ubian.cardBuyType.getCardType()),
    method: "POST",
    data: $formData,
    cache: false,
    contentType: false,
    processData: false,
  }).done(function (result) {
    $("#photo").val("");
    $(".js-photo-preview-wrapper").removeClass("loading");
    if (result.error) {
      ubian.utils.alert(ubian.translate(result.error));
      $(".js-photo-preview-wrapper").addClass("empty");
    } else if (result.url) {
      $(".js-photo-preview").css(
        "background-image",
        'url("' + result.url + "&v=" + new Date() * 1 + '")'
      );
      cropper.destroy();

      $("#photo").val(null);
      ubian.card_buy_photo.DisableCropperDeps();
      ubian.cardBuyType.updateContinueButton();
    }
  }).fail(function (xhr, status, error) {
    console.log("Error : " + error);
  });
};

ubian.cardBuy.removeUploadedPhoto = function () {
  $.post(ubian.routes["card_buy_remove_upload"], { fileType: "1" });
};

ubian.cardBuy.submitBuyForm = function (event) {
  if ($(event.target).parents(".card-buy-screen").length == 0) {
    return;
  }
  var $form = $("#js-card-buy-form");
  if ($form.length) {
    $form.submit();
  }
};

ubian.cardBuy.updateCompanySettings = function (companyId) {
  $.post(
    ubian.routes["card_buy_card_sell_settings"],
    { companyId: companyId },
    function (result) {
      ubian.cardBuy.updateAllowedUserBirthDate(result.allowedYears);
      var deliveryDiv = "";
      var $anotherAddressForm = $(".js-another-address-form")
        .remove()
        .addClass("d-none");
      $.each(result["deliveryTypes"], function (idx, obj) {
        deliveryDiv += ubian.cardBuy.createDeliveryPoint(
          obj["deliveryType"],
          result["deliveryPoints"]
        );
        if (idx != result["deliveryTypes"].length - 1) {
          deliveryDiv += '<div class="separator-horizontal"></div>';
        }
      });
      $(".js-delivery-card-buy-container").empty();
      $(".js-delivery-card-buy-container")
        .html(deliveryDiv)
        .append($anotherAddressForm);
    }

  );
};

ubian.cardBuy.updateAllowedUserBirthDate = function (allowedYears) {
  var yearInput = $(".js-user-birth-date select.year");
  var currentSelectedYear = yearInput.selectpicker("val");
  var isInvalidYear =
    !currentSelectedYear ||
    currentSelectedYear > allowedYears.max ||
    currentSelectedYear < allowedYears.min;
  if (isInvalidYear) {
    $(".js-user-birth-date input").val(null);
    $(".js-user-birth-date select.day").selectpicker("val", "");
    $(".js-user-birth-date select.month").selectpicker("val", "");
  }
  var options =
    "<option disabled hidden " +
    (isInvalidYear ? "selected" : "") +
    "></option>";
  for (i = allowedYears.max; i >= allowedYears.min; i--) {
    options =
      options +
      "<option " +
      (currentSelectedYear == i ? "selected" : "") +
      ' value="' +
      i +
      '">' +
      i +
      "</option>";
  }
  yearInput.html(options);
  yearInput.selectpicker("refresh");
};

ubian.cardBuy.createDeliveryPoint = function (
  deliveryType,
  personalPickupPlaces
) {
  var htmlString =
    '<div class="delivery-type"><label class="container-radio-input">' +
    '<input class="js-delivery-type" value="' +
    deliveryType["deliveryType"] +
    '" type="radio" name="delivery[type]">' +
    '<span class="custom-checkmark"></span>' +
    '<span class="delivery-content d-flex align-items-center">' +
    '<span class="icon-card-delivery icon-card-' +
    deliveryType["deliveryType"].toLowerCase() +
    '"></span>' +
    '<span class="delivery-container-text">' +
    '<span class="delivery-title">' +
    deliveryType["translation"] +
    "</span><br />" +
    '<span class="delivery-price">' +
    deliveryType["price"]["price"]["value"].toString().replace(".", ",") +
    " " +
    deliveryType["price"]["price"]["currencySymbol"] +
    "</span>" +
    "</span></label>";

  //htmlString += "</div>";
  if (deliveryType["deliveryType"] == "PersonalPickup") {
    htmlString +=
      '<div class="align-items-center container-personal-pickup flex-column flex-lg-row"><div class="col-xs-12 col-md-6"><select name="delivery[pickUp]" class="custom-select" required ><option value="" disabled selected hidden>' +
      ubian.translate("Card.Buy.Delivery.ChoosePickup") +
      "</option>";
    $.each(personalPickupPlaces, function (idx, value) {
      htmlString +=
        '<option class="custom-select" value="' +
        value["deliveryPoint"]["id"] +
        '">' +
        value["deliveryPoint"]["name"] +
        "</option>";
    });
    htmlString +=
      '</select></div><div class="col-xs-12 col-md-6"><div class="d-flex align-items-center"></div></div>';
  }
  htmlString += "</div>";
  console.log(htmlString);
  return htmlString;
};

ubian.cardBuy.checkInputFields = function () {
  $(".btn-continue").removeAttr("disabled");
};

ubian.cardBuy.init = function () {
  // force open groups with errors
  $(".card-buy-title-container-mobile")
    .not(".open")
    .each(function () {
      if ($(this).next().find(".red").length) {
        $(this).addClass("open");
        $(this).next(".card-buy-container").show();
      }
    });

  if ($("body").hasClass("buy-card--first")) {
    $("body").on("change", "#birthDate", function () {
      ubian.cardBuy.checkUserBirthDate();
    });
    $(".btn-continue").on("click", function (event) {
      ubian.cardBuy.submitBuyForm(event);
    });
    $("#js-card-buy-form").on(
      "change",
      "#anotherAddressCheckbox input[type=checkbox]",
      function (event) {
        event.preventDefault();
        $(".js-another-address-fields").toggle();
        $(".js-another-address-fields input[type=text]").val("");
        setTimeout(function () {
          ubian.cardBuy.checkInputFields();
        }, 1000);
      }
    );
    $(".card-buy-title-container-mobile").on("click", function (e) {
      var targetTitle = $(this);
      $(this).toggleClass("open");
      $(this).next().slideToggle();
      if (targetTitle.hasClass("open")) {
        $([document.documentElement, document.body]).animate(
          { scrollTop: targetTitle.offset().top - 135 },
          500
        );
      }
    });

    $("#companies").change(function () {
      var id = $(this).val();
      if (id != null) {
        ubian.cardBuy.updateCompanySettings(id);
      }
      //$(".js-optionArrivaNitraUse").toggle(id == 811);
      if (id != 811) {
        $(".js-optionArrivaNitraUse input[type=radio]").prop("checked", false);
      }
      if (id == 816) {
        ubian.utils.alert(ubian.translate('JS.Error.CardBuy.Company.816'));
      }
    });

    $("#js-card-buy-form").on("change", ".js-delivery-type", function () {
      var anotherAddressTypes = ["Courier", "PostToAddress"];

      $(".js-delivery-type").removeAttr("checked");
      $(this).attr("checked", "checked");

      $anotherAddressForm = $(".js-another-address-form")
        .remove()
        .addClass("d-none");
      $(".js-delivery-card-buy-container").append($anotherAddressForm);
      ubian.cardBuy.initAddressFiller('.js-another-address-form');
      $(".checked-delivery").removeClass("checked-delivery");
      $($(this).parents(".delivery-type")[0]).addClass("checked-delivery");

      if (
        $.inArray($(this).val(), anotherAddressTypes) != -1 &&
        $(this).is(":checked")
      ) {
        var $anotherAddressForm = $(".js-another-address-form")
          .remove()
          .removeClass("d-none");
        $($(this).parents(".delivery-type")[0]).append($anotherAddressForm);
        ubian.cardBuy.initAddressFiller('.js-another-address-form');
      }
    });
    var timeout;
    $("#js-card-buy-form").on("keyup change", "input", function () {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        ubian.cardBuy.checkInputFields();
      }, 1000);
    });
    ubian.cardBuy.checkInputFields();
  }
  ubian.cardBuy.initAddressFiller();
};

ubian.cardBuy.initAddressFiller = function (selector) {
  $((selector ? selector + ' ' : '') + ".js-address-fillable").each(function () {
    var $fillable = $(this);
    var $field = $(this).find(".js-street-field");
    var $cityField = $(this).find(".js-town-field");
    var $postcodeField = $(this).find(".js-postcode-field");
    var $list = $(this).find(".js-street-autocomplete");
    var timeout = null;
    var postcode = null;
    function loadResults() {
      if (!$field.val() || $field.val().length < 3) {
        $list.hide();
        return;
      }
      $.get(
        ubian.routes['api_autocomplete_address'],
        { q: $field.val(), postcode: postcode || "" },
        function (res) {
          $list.html("");
          if (!res || (!res.houses.length && !res.streets.length)) {
            $list.hide();
          } else {
            insertResults(res);
            $list.show();
          }
        }
      );
    }
    $list.on("click", "span", function () {
      selectOption($(this));
    });

    function selectOption(elem) {
      var location = $(elem).data("location");
      if ($fillable.data('vue-fillable')) {
        window.dispatchEvent(new CustomEvent('vueFillableEvent', {
          detail: {
            'fillable': $fillable.data('vue-fillable'),
            street: getFullStreet(location) + (location.code ? "" : " "),
            postcode: location.postcode,
            city:
              location.city +
              (location.city == location.city_part || !location.city_part
                ? ""
                : " - " + location.city_part)
          }
        }));
      } else {
        $field.val(getFullStreet(location) + (location.code ? "" : " "));
        $postcodeField.val(location.postcode);
        $cityField.val(
          location.city +
          (location.city == location.city_part || !location.city_part
            ? ""
            : " - " + location.city_part)
        );
      }

      if (location.code) {
        $list.hide();
      } else {
        $field.focus();
        postcode = location.postcode;
        loadResults();
      }
    }

    function selectActiveOption() {
      if ($list.find(".active").length) {
        selectOption($list.find(".active"));
      }
    }

    function getFullStreet(res) {
      return (
        res.street +
        (res.code ? " " + res.code + (res.number ? "/" + res.number : "") : "")
      );
    }
    function insertResults(res) {
      var items = [];
      if (res.streets) {
        $(res.streets).each(function (idx, val) {
          var str = formatSelectOption(val);
          var item = $("<span>" + str + "</span>");
          item.data("location", val);
          items.push(item);
        });
      }
      if (res.houses) {
        $(res.houses).each(function (idx, val) {
          var str = formatSelectOption(val);
          var item = $("<span>" + str + "</span>");
          item.data("location", val);
          items.push(item);
        });
      }
      $list.append(items);
    }

    function formatSelectOption(row) {
      return (
        getFullStreet(row) +
        "<i>" +
        row.postcode +
        ", " +
        row.city +
        (row.city == row.city_part || !row.city_part
          ? ""
          : " - " + row.city_part) +
        "</i>"
      );
    }

    function moveSelection(direction) {
      var $active = $list.find(".active");
      if (direction == "down") {
        if (!$active.length) {
          $list.find("span").first().addClass("active");
        } else {
          if ($active.next("span").length) {
            $active.removeClass("active");
            $active.next("span").addClass("active");
          }
        }
      }
      if (direction == "up") {
        if (!$active.length) {
          $list.find("span").last().addClass("active");
        } else {
          if ($active.prev("span").length) {
            $active.removeClass("active");
            $active.prev("span").addClass("active");
          }
        }
      }
      $list.find(".active")[0].scrollIntoView(true);
    }
    var hideTimeout = null;
    $field.on("focus", function () {
      $(this).attr("autocomplete", "off");
      if (hideTimeout) {
        clearTimeout(hideTimeout);
      }
    });
    $field.on("blur", function () {
      $(this).removeAttr("autocomplete");
      if (hideTimeout) {
        clearTimeout(hideTimeout);
      }
      hideTimeout = setTimeout(function () {
        $list.hide();
      }, 250);
    });
    $field.on("keyup", function (e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode == 8 || keyCode == 46) {
        postcode = null;
      }
      if (keyCode == 38 || keyCode == 40) {
        moveSelection(keyCode == 38 ? "up" : "down");
        return;
      }
      if (keyCode == 13) {
        selectActiveOption();
        return;
      }
      if (keyCode == 27) {
        $list.hide();
        return;
      }
      if (timeout) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(function () {
        loadResults();
      }, 250);
    });
  });
};

$(ubian.cardBuy.init);
